module.exports = __webpack_public_path__ + "img/product_40.69f990f.webp";